import {__} from "./__";

export const getFilesNames = () => {
    return {
        'Product parameters for AI': __('Parametre produktov pre AI'),
        'Eshop category words for AI': __('Kategórie produktov pre AI'),
    };
};
